import { useSelector } from "react-redux";
import {
  selectSelectedElement,
  selectSequenceVariables,
} from "../../app/slices/TrainingSlice";
import { LisaMessage } from "../../models/interactions/LisaMessage";
import { useTrainingLocalization } from "../trainingLocalization/TrainingLocalizationHooks";
import { selectCurrentLanguage } from "../../app/slices/TrainingLocalizationSlice";
import RichTextEditor from "../rich_text/RichTextEditor";
import "./LisaMessagePreview.css";

export default function LisaMessagePreview() {
  const lisaMessageData = useSelector(selectSelectedElement) as LisaMessage;
  const { getValue, changeValue } = useTrainingLocalization();
  const currentLanguage = useSelector(selectCurrentLanguage);
  const variables = useSelector(selectSequenceVariables);
  const localizedValue = getValue(lisaMessageData.message);

  return (
    <div className="lisamessagepreview-root">
      <div className="lisamessagepreview-position">
        <div className="lisamessagepreview-text-wrapper">
          <div className="lisamessagepreview-text">
            <RichTextEditor
              ariaLabel="lisamessage-text-area"
              value={localizedValue}
              onCommit={(nextValue) =>
                changeValue(lisaMessageData.message, nextValue, currentLanguage.shortcode)
              }
              variables={variables}
              debounceMs={250}
              flushOnCleanupKeys={[currentLanguage.shortcode, lisaMessageData.message]}
              className="lisamessagepreview-variable-field"
              contentClassName="lisamessagepreview-rich-text"
              suggestionsMaxWidth={520}
            />
          </div>
          <div className="lisamessagepreview-arrow">
            <img src="arrow.png" alt="" />
          </div>
        </div>

        <div className="lisamessagepreview-img">
          <img aria-label="lisamessage-image" src="/lisa.png" alt="" />
        </div>
      </div>
    </div>
  );
}
